import { position } from '../api/entities';

export const actions = {
  listPosition: 'LIST_POSITION',
};

export function getPositions(query) {
  return position.list(actions.listPosition, query, null, true);
}

const INITIAL_STATE = {
  positions: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.listPosition:
      return {
        ...state,
        positions: action.body ? action.body._items : state.positions,
      };
    default:
      return {
        ...state,
      };
  }
}
